import { Model } from './model';
import { Vendor } from './vendor';
import { Type } from 'class-transformer';

export class InventoryItem extends Model {
  id: string;

  name: string;

  @Type(() => Vendor)
  vendor: Vendor | null;
}
